import { BREAKPOINT_MEDIUM } from '@big-red-group/storefront-common-ui'
import styled from 'styled-components'

export const IndividualMessages = styled.div`
  > button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
  }
`
export const IndividualMessageWrap = styled.div<{ firstItem: boolean; lastItem: boolean }>`
  border: 1px solid var(--grey-25);
  border-bottom: 0;
  overflow: hidden;

  ${({ firstItem }) =>
    firstItem &&
    `
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  `}

  ${({ lastItem }) =>
    lastItem &&
    `
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-bottom: 1px solid var(--grey-25);
  `}
`
export const IndividualMessageForm = styled.div`
  padding: 25px;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    padding: 20px;
  }
`
export const IndividualMessageWrapIcon = styled.div`
  width: 28px;
  height: 28px;
  border: 2px solid var(--grey-100);
  color: var(--grey-100);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    width: 24px;
    height: 24px;

    svg {
      width: 12px;
      height: 12px;
    }
  }
`
export const ViewMessage = styled.div`
  margin-left: auto;
  padding-right: 5px;
  text-decoration: underline;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;

  &:hover {
    text-decoration: none;
  }

  svg {
    transition: 0.2s ease-in-out;
  }
`
export const IndividualMessageWrapSession = styled.div<{ active: boolean; complete: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding: 15px;
  background: var(--grey-10);
  color: var(--grey-100);

  ${({ active }) =>
    active &&
    `
    color: var(--brand-secondary);

    ${IndividualMessageWrapIcon} {
      color: var(--brand-secondary);
      border-color: var(--brand-secondary);
    }

  `}
  ${({ complete }) =>
    complete &&
    `
    color: var(--ui-green);

    ${IndividualMessageWrapIcon} {
      color: var(--ui-green);
      border-color: var(--ui-green);
    }
  `}
`

export const MessagePreview = styled.div`
  padding: 25px;
  width: 100%;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: minmax(0, 25%) minmax(0, 25%) minmax(0, 50%);
  gap: 20px;
  align-items: flex-start;

  > div {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 8px;
  }

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    grid-template-columns: 100%;
    gap: 0px;
  }
`
